<template>
    <div>
        <home-detail :scene="scene">
            <template #main>
                <p>
                    Our company, founded in 2006, provides casting for films, documentaries, commercials and any
                    audiovisual works.
                </p>
                <p>
                    We will prepare voice or face casting according to your specifications. Please send us your brief or
                    call for more information.
                </p>
                <hr />
                <h1>ACTORS AND SPEAKERS</h1>
                <p>
                    Voicecasting is an ONLINE professional database with original audio samples and photos of actors and
                    speakers from many origins, nationalities, languages. Their numbers increases every month.
                </p>
                <p>
                    All voices / actors in the database are native speakers and are available for recording and
                    shooting. Listen to voice samples, choose from photos, create shortlists, sent them to your clients,
                    order actors for recording / shooting.
                </p>

                <hr />

                <div class="table table-contacts">
                    <div class="item">
                        <div class="column">
                            <div><span class="name">Henrich Platek</span></div>
                            <div><span class="role">voice & face agent</span></div>
                        </div>
                        <div class="column">
                            <div>
                                <span><span class="icon">phone</span></span>
                                <span><a href="tel:00421905682931">+421 905 682 931</a></span>
                            </div>
                            <div>
                                <span><span class="icon">mail_outline</span></span>
                                <span>
                                    <a href="mailto:henrich.platek@voicecasting.sk">henrich.platek@voicecasting.sk</a>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="item">
                        <div class="column">
                            <div><span class="name">Silvia Balcová</span></div>
                            <div><span class="role">voice & face agent</span></div>
                        </div>
                        <div class="column">
                            <div>
                                <span><span class="icon">phone</span></span>
                                <span><a href="tel:00421905756176">+421 905 756 176</a></span>
                            </div>
                            <div>
                                <span><span class="icon">mail_outline</span></span>
                                <span><a href="mailto:silvia@voicecasting.sk">silvia@voicecasting.sk</a></span>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </home-detail>
    </div>
</template>
<script>
import HomeDetail from '@/components/Home/HomeDetail.vue';
import NavButton from '@/components/.global/NavButton.vue';
import Btn from '@/components/.global/Btn.vue';
import Mp3Player from '@/components/.global/Mp3Player.vue';
export default {
    name: 'About',

    props: {
        scene: {
            type: String,
            required: false,
        },
    },

    components: {
        HomeDetail,
        NavButton,
        Mp3Player,
        Btn,
    },
};
</script>
<style lang="less" scoped>
@import '~@variables';

hr {
    padding-bottom: 20px;
    margin-top: 20px;
}

.table {
    display: flex;
    flex-direction: column;

    div {
        display: flex;
        & > span {
            padding: 5px;
            &:first-child {
                width: 130px;
                min-width: 130px;
                padding-left: 0;
            }
            &:last-child {
                font-weight: 700;
            }
        }
    }

    &.table-contacts {
        width: 100%;
        flex-wrap: wrap;
        align-items: flex-start;
        flex-direction: column;

        .item {
            width: 100%;
            margin: 8px 0;
            flex-direction: row;

            @media (max-width: 449px) {
                flex-direction: column;
            }

            .column {
                flex-direction: column;

                &:first-child {
                    width: 33%;
                    padding-right: 15px;

                    @media (max-width: 449px) {
                        width: auto;
                    }
                }

                & > div {
                    span {
                        font-weight: 400;
                        padding: 2px 5px 2px 0;

                        &:first-child {
                            width: auto;
                            min-width: auto;
                        }

                        &.name {
                            color: #000;
                            font-weight: 900;
                            font-size: 15px;
                            padding-bottom: 0;
                            line-height: 1;
                        }

                        &.role {
                            padding-top: 0;
                        }
                    }

                    .icon {
                        display: block;
                        font-size: 17px;
                    }
                }
            }
        }

        a {
            color: #555;
            font-weight: 600;
            word-break: break-all;
            text-decoration: none;

            &:hover {
                color: @accent;
            }
        }

        h3 {
            margin: 0;
        }
    }
}
</style>
